import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable max-len */
/* global SentryDsn, SentryRelease, SentryEnvironment */
import * as Sentry from '@sentry/browser';
require('bootstrap');
Sentry.init({
  dsn: SentryDsn,
  release: SentryRelease,
  environment: SentryEnvironment
});
if (document.getElementById('score-board')) {
  import( /* webpackChunkName: "scoresApp" */'./modules/scoresApp').then(function (_ref) {
    var scoresApp = _ref["default"];
    scoresApp.init();
  })["catch"](function () {
    return 'An error occurred while loading the component scoresApp';
  });
}
if (document.getElementById('print_qrcodes')) {
  import( /* webpackChunkName: "printQRCodes" */'./print-qrcodes')["catch"](function () {
    return 'An error occurred while loading the component printQRCodes';
  });
}
if (document.getElementById('manage_qr_codes')) {
  import( /* webpackChunkName: "manageQRCodes" */'./manage-qrcodes')["catch"](function () {
    return 'An error occurred while loading the component manageQRCodes';
  });
}
if (window.parent.document.getElementById('theIframe')) {
  import( /* webpackChunkName: "theIframe" */'./modules/the-iframe').then(function (_ref2) {
    var theIframe = _ref2["default"];
    theIframe.init();
  })["catch"](function () {
    return 'An error occurred while loading the component theIframe';
  });
}
if (document.getElementsByClassName('clickable').length) {
  import( /* webpackChunkName: "clickable" */'./modules/clickable').then(function (_ref3) {
    var clickable = _ref3["default"];
    clickable.init();
  })["catch"](function () {
    return 'An error occurred while loading the component clickable';
  });
}
if (document.getElementsByClassName('main-navigation-container').length) {
  import( /* webpackChunkName: "navigation" */'./modules/main-navigation').then(function (_ref4) {
    var mainNavigation = _ref4["default"];
    mainNavigation.init();
  })["catch"](function () {
    return 'An error occurred while loading the component navigation';
  });
}
if (document.getElementsByClassName('responsive-image').length) {
  import( /* webpackChunkName: "responsiveImages" */'./modules/responsive-images').then(function (_ref5) {
    var responsiveImages = _ref5["default"];
    responsiveImages.init();
  })["catch"](function () {
    return 'An error occurred while loading the component responsiveImages';
  });
}
if (document.getElementsByClassName('photo-rotator').length) {
  import( /* webpackChunkName: "photoRotator" */'./modules/photo-rotator').then(function (_ref6) {
    var photoRotator = _ref6["default"];
    photoRotator.init();
  })["catch"](function () {
    return 'An error occurred while loading the component photoRotator';
  });
}
if (document.getElementById('footer-content') && document.getElementById('main-container') && document.getElementById('footer-container')) {
  import( /* webpackChunkName: "sticky-footer" */'./modules/sticky-footer').then(function (_ref7) {
    var stickyFooter = _ref7["default"];
    stickyFooter.init();
  })["catch"](function () {
    return 'An error occurred while loading the component stickyFooter';
  });
}
if (document.getElementsByClassName('searchResults').length) {
  import( /* webpackChunkName: "searchResults" */'./modules/search-results').then(function (_ref8) {
    var searchResults = _ref8["default"];
    searchResults.init();
  })["catch"](function () {
    return 'An error occurred while loading the component searchResults';
  });
}
if (document.getElementsByClassName('doForm').length) {
  import( /* webpackChunkName: "form" */'./modules/form').then(function (_ref9) {
    var form = _ref9["default"];
    form.init();
  })["catch"](function () {
    return 'An error occurred while loading the component form';
  });
}
if (document.getElementsByClassName('countdown').length) {
  import( /* webpackChunkName: "countdown" */'./modules/countdown').then(function (_ref10) {
    var countdown = _ref10["default"];
    countdown.init();
  })["catch"](function () {
    return 'An error occurred while loading the component countdown';
  });
}
if (document.querySelector('input.duplicate')) {
  import( /* webpackChunkName: "duplicate" */'./modules/duplicate').then(function (_ref11) {
    var duplicate = _ref11["default"];
    duplicate.init();
  })["catch"](function () {
    return 'An error occurred while loading the component duplicate';
  });
}
if (document.querySelector('a[role="tab"]')) {
  import( /* webpackChunkName: "tab" */'./modules/tab').then(function (_ref12) {
    var tab = _ref12["default"];
    tab.init();
  })["catch"](function () {
    return 'An error occurred while loading the component tab';
  });
}
var eqh = document.querySelectorAll('[data-equalheight]');
if (eqh.length) {
  import( /* webpackChunkName: "equalHeight" */'./modules/equal-height').then(function (_ref13) {
    var equalHeight = _ref13["default"];
    equalHeight.init(eqh);
  })["catch"](function () {
    return 'An error occurred while loading the component equalHeight';
  });
}
import( /* webpackChunkName: "removeEmptyParagraphs" */'./modules/remove-empty-paragraphs').then(function (_ref14) {
  var removeEmptyParagraphs = _ref14["default"];
  removeEmptyParagraphs.init();
})["catch"](function () {
  return 'An error occurred while loading the component removeEmptyParagraphs';
});
import( /* webpackChunkName: "posts" */'./modules/posts').then(function (_ref15) {
  var posts = _ref15["default"];
  posts.init();
})["catch"](function () {
  return 'An error occurred while loading the component posts';
});
import( /* webpackChunkName: "links" */'./modules/links').then(function (_ref16) {
  var links = _ref16["default"];
  links.init();
})["catch"](function (_error) {
  return 'An error occurred while loading the component links';
});
if (document.getElementsByClassName('toForm')) {
  import( /* webpackChunkName: "filterForm" */'./modules/filterForm').then(function (_ref17) {
    var filterForm = _ref17["default"];
    filterForm.init();
  })["catch"](function () {
    return 'An error occurred while loading the component filterForm';
  });
}
if (document.getElementById('gzg-cosplay')) {
  import( /* webpackChunkName: "cosplay" */'./modules/cosplay')["catch"](function () {
    return 'An error occurred while loading the component cosplay';
  });
}
if (document.getElementsByClassName('collapse').length > 0) {
  import( /* webpackChunkName: "collapse" */'./modules/collapse').then(function (_ref18) {
    var collapse = _ref18["default"];
    collapse.init();
  })["catch"](function () {
    return 'An error occurred while loading the component collapse';
  });
}
if (document.getElementById('v-smashgg-tournament-rules')) {
  import( /* webpackChunkName: "rules" */'./modules/smashgg-tournament-rules')["catch"](function () {
    return 'An error occurred while loading the component rules';
  });
}
var sorted = document.getElementsByClassName('sort');
//console.log(sorted);
if (sorted.length) {
  import( /* webpackChunkName: "sort" */'./modules/sort').then(function (_ref19) {
    var sort = _ref19["default"];
    sort.init(sorted);
  })["catch"](function () {
    return 'An error occurred while loading the component sort';
  });
}